/**
 * The key prefix for file sharing metadata in the conference.
 */
export const FILE_SHARING_PREFIX = 'files';
/**
 * Used for requesting file sharing service short-term credentials.
 */
export const FILE_SHARING_SERVICE = 'file-sharing';
/**
 * The max file size we accept for upload.
 */
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
